import {injectable} from "inversify";
import {ColorEnum, IconEnum} from "@/modules/vue/enums";

export type MenuNavigationItemComponent = {
  color: ColorEnum,
  icon: string | IconEnum,
  route: { name: string, params?: object },
}

@injectable()
export class MenuNavigationComponentManager {
  private items: MenuNavigationItemComponent[] = [];

  public addItem(item: MenuNavigationItemComponent) {
    this.items.push(item);

    return this;
  }

  public getItems(): MenuNavigationItemComponent[] {
    return this.items;
  }
}